import React, { useRef, useState } from "react";
//import { getFile } from "../../../actions/CarrierAgreementMgmt/Agreements";
import DownloadButton from "../../../../components/DownloadButton";
import { downloadSourceFile } from "../../../../actions/Utilities/Common";
import { toast } from "../../../../components/toastNotification";
import MinusButton from "../../../../components/MinusButton";
import AddButton from "../../../../components/AddButton";
import Modal from "../../../../components/Modal";

const downloadFile = (fileName) => {
  try {
    downloadSourceFile(fileName).then((content) => {
      if (content.status === 200) {
        var url = window.URL.createObjectURL(content.data);
        let tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        toast.fire("Success", "File Downloaded Successfully", "success");
      }
      if (content.status === 404) {
        toast.fire("Error Downloading File:", "File not found", "error");
      }
    });
  } catch (error) {
    toast.fire(
      "Failed to Download File",
      "Server Error: Cannot download file due to: " + error,
      "error"
    );
  }
};
const AttachmentDetails = ({ showAttachments = [] }) => {
  if (showAttachments.length === 0) {
    return (
      <div className="flex justify-center text-xs italic col-span-3">
        No Attachment/s Found
      </div>
    );
  }

  return (
    <div className=" text-xs">
      {showAttachments.map((file, i) => {
        return (
          <div key={i}>
            <div className="pt-2">
              <span className="text-primary font-bold">{file.State}</span>
            </div>
            {file.Filename.map((files, fIndex) => {
              return (
                <div key={fIndex} className="p-1 space-y-2">
                  <div className="p-2 bg-LightWhite flex justify-between items-center space-x-4 py-1 border-b">
                    <div className="">{files.sourceLink}</div>
                    <div className="">
                      <DownloadButton
                        buttonValue="Download"
                        onClick={() => {
                          downloadFile(files.sourceLink);
                        }}
                        className=""
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

const AttachmentForm = ({
  setAgmtSourceFiles,
  setNewAttachmentRow,
  setFilesForUpload,
  newAttachmentRow,
}) => {
  const removeFile = () => {
    setAgmtSourceFiles();
    setFilesForUpload();
    setNewAttachmentRow();
  };

  return (
    <div className="divide-y justify-between">
      {newAttachmentRow && (
        <div className="p-2 bg-LightWhite flex items-center place-items-center">
          <div className="text-xs font-semibold text-primary mr-auto ">
            {newAttachmentRow.Filename.sourceLink}
          </div>
          <div className="place-self-center">
            <MinusButton
              onClick={() => {
                removeFile();
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const AddAttachmentsButton = ({
  setFilesForUpload,
  setAgmtSourceFiles,
  setNewAttachmentRow,
  showAttachments,
  newAttachmentRow,
  isShow = false,
  onClose,
  isOpen,
}) => {
  return (
    <>
      {!isShow ? (
        <div className="">
          <div className="grid grid-cols-2 px-4">
            <div className="text-primary font-bold font-sans text-sm py-3">
              Attachment
            </div>
            <div className="text-right py-2">
              <label
                className="hover:scale-90 transition duration-500 bg-tranparent 
                    border-primary shadow-md hover:bg-primary text-primary group relative  py-1 px-2 border text-xs 
                    font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 
                    focus:ring-primary focus:ring-opacity-70"
              >
                <input
                  type="file"
                  multiple="multiple"
                  className="hidden p-4"
                  onChange={(e) => {
                    if (e.target.files && e.target.files.length > 0) {
                      const forUploadFiles = new FormData();
                      forUploadFiles.append("file", e.target.files[0]);

                      var reader = new FileReader();
                      reader.readAsDataURL(e.target.files[0]);
                      reader.onload = () => {
                        setNewAttachmentRow({
                          Filename: {
                            sourceLink: e.target.files[0].name,
                            file: reader.result.split(";base64,")[1],
                          },
                        });
                        setFilesForUpload(e.target.files[0]);
                        //agmtSourceFiles for saving sourcefile table
                        setAgmtSourceFiles({
                          sourceLink: e.target.files[0].name,
                          file: reader.result.split(";base64,")[1],
                        });
                      };
                    }
                  }}
                />
                Choose File
              </label>
            </div>
          </div>

          <div className={"color:red grid grid-cols-1"}>
            {!isShow && (
              <div className="mx-4">
                <div className="">
                  <div className="">
                    <AttachmentForm
                      newAttachmentRow={newAttachmentRow}
                      setFilesForUpload={setFilesForUpload}
                      setAgmtSourceFiles={setAgmtSourceFiles}
                      setNewAttachmentRow={setNewAttachmentRow}
                    />
                  </div>
                </div>
              </div>
            )}

            {isShow && <AttachmentDetails showAttachments={showAttachments} />}
          </div>
        </div>
      ) : (
        <Modal isOpen={isOpen} onClose={onClose} width="fit">
          <div className="">
            <div className="flex justify-between items-center">
              <div className="text-primary font-bold">
                {"Attachment Details"}
              </div>
              {!isShow && (
                <div className="w-1/2">
                  <AddButton
                    className={"w-1/6 ml-auto"}
                    buttonText="New Commission"
                    //  onClick={() => GenerateInput()}
                  />
                </div>
              )}
            </div>
            <hr className="h-1 bg-secondary" />
            <div className="divide-y gap-y-2">
              {<AttachmentDetails showAttachments={showAttachments} />}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AddAttachmentsButton;
